import React, { Component } from 'react';

import ContentReminders from '../../components/User-Settings/ContentReminders';
import ContentLanguage from '../../components/User-Settings/ContentLanguage';
import ContentParental from '../../components/User-Settings/ContentParental';
import ContentBlockedChannels from '../../components/User-Settings/ContentParental/ContentBlockedChannels';
import ContentSubscriptions from '../../components/User-Settings/ContentSubscriptions';
import ContentRemoteControl from '../../components/User-Settings/ContentRemoteControl';
import Translator from "../../requests/apa/Translator";
import ContentUpdateEpg from '../../components/User-Settings/ContentUpdateEpg';

class ContainerSection extends Component {


  render() {

    let sectionToRender;
    switch(this.props.section) {
      case 'idioma':
        sectionToRender = <ContentLanguage text={Translator.get('language_settings', 'Aquí podés configurar el idioma y subtítulos.')} notApply={Translator.get('language_settings_not_apply', 'No aplica para canales de TV.')} />
        break;

      case 'recordatorios':
        sectionToRender = <ContentReminders text={Translator.get('reminder_settings', 'Desde acá podrás tener una visualización rápida de tus programas agendados.')} />;
        break;


      case 'subscriptions':
        sectionToRender = <ContentSubscriptions text={Translator.get('subscriptions_settings', 'Validar todas las suscripciones.')} />;
        break;
      case 'parental_control_tv_config':
        if (!this.props.subsection) {
          sectionToRender =
            <div>
              <ContentParental id="canales"
                               title={Translator.get('channel_parental_control_settings_title', 'Bloqueo de canales')}
                               text={Translator.get('channel_parental_control_settings_description', 'Te permite bloquear canales que consideres inapropiados para tus hijos. Desde la ficha de evento en la Guia de Programacion. Necesitaras el PIN cada vez que quieras acceder a ellos.')}
                               buttonText={Translator.get('content_parental_control_settings_button_text', 'Modificar')}
                               display={ true }
                               headButtons={ true }
                               typeButton='button'
                               status={this.props.status}
                               toggleStatus={this.props.toggleStatus}
              />
            </div>;
        } else {
          sectionToRender = <ContentBlockedChannels text={Translator.get('blocked_channel_parental_control_settings_title', 'Canales bloqueados')}/>;
        }
        break;
      case 'parental_control_content_config':
        sectionToRender =
          <div>
            <ContentParental
              id="contenidos"
              title={Translator.get('content_parental_control_settings_title', 'Clasificación de contenidos')}
              text={Translator.get('content_parental_control_settings_description', 'Te ayudamos a proteger a tus hijos de contenidos inapropiados seleccionando la clasificación del contenido segun tus necesidades:')}
              display={ true }
              headButtons={ false }
              typeButton='select'
              status={this.props.status}
              toggleStatus={this.props.toggleStatus}
            />
            <ContentParental id="pagos"
                             title={Translator.get('payment_parental_control_settings_title', 'Protección de pagos')}
                             text={Translator.get('payment_parental_control_settings_description', 'Te permite tener el control de todas tus rentas y compras. Al activar la Protección de Pagos te solicitaremos el PIN cada vez que rentes o compres un contenido.')}
                             display={ false }
                             headButtons={ false }
                             status={this.props.status}
                             toggleStatus={this.props.toggleStatus}
            />
          </div>;
        break;
      case 'remote_control':
        sectionToRender =
          <div>
            <ContentRemoteControl
              title={Translator.get('remote_control_settings_title', 'Elige tu control remoto')}
              currentRemoteControl={Translator.get('remote_control_settings_current', 'Actualmente estas usando el control remoto')}
            >
            </ContentRemoteControl>
          </div>
        break;
      case 'update_epg':
        sectionToRender =
          <div>
            <ContentUpdateEpg
              title={Translator.get('update_epg_title', 'Actualización de la Guía de programación')}
            >
            </ContentUpdateEpg>
          </div>
        break;
      default:
        if (this.props.subsection)
          sectionToRender = <ContentBlockedChannels text={Translator.get('blocked_channel_parental_control_settings_title', 'Canales bloqueados')}/>;

    }

    return(
      <div className="ContainerSection">
        { sectionToRender }
      </div>
    );
  }
}

export default ContainerSection;



// WEBPACK FOOTER //
// ./src/containers/User-Settings/ContainerSection.jsx